'use client';
import { useVal } from '../../val/val.client';
import notFound from '../../settings/notFound.val';
import { ValImage } from '@valbuild/next';

const NotFound = () => {
  const { header, subHeader, image } = useVal(notFound);

  return (
    <div className="relative w-screen h-screen pt-header-height pb-16 px-16">
      <div className="absolute top-1/2 left-1/2 translate-x-[-50%] translate-y-[-50%] z-10">
        <div className="flex flex-col items-center gap-4 text-center px-4">
          <h1 className="font-respira text-respira-lg tablet:text-respira-xl">
            {header}
          </h1>
          <p className="max-w-[30rem] text-lg tablet:text-xl text-pretty">
            {subHeader}
          </p>
        </div>
      </div>
      <ValImage
        className={'h-full object-contain mx-auto'}
        src={image.content}
        alt={image.content.alt}
      />
    </div>
  );
};

export default NotFound;
